import {
  AddressCard,
  Box,
  CollapsibleCard,
  IconButton,
  TableCell,
  TableRow,
} from '@atgfr8/atg-ui-tailwind';
import { BasicModal, BasicTable, Button } from '@components';
import { Contact } from '@store/customers/customerDetails';
import { closeModal, openModal } from '@store/modals';
import { DeleteIcon, AccountPlusIcon } from '@atgfr8/icons';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { AddNewContact } from '@views/order/components';
import { Index, Show, createSignal } from 'solid-js';

import {
  createCustomerStore,
  setupNewCustomerState,
} from '../NewCustomerTabPanel';
import { contactModalId } from '../constants';

const CustomerContact = () => {
  const [selectedContact, setSelectedContact] = createSignal<Contact | null>(
    null,
  );

  const columns = [{ name: 'Name' }, { name: 'Type' }, { name: 'Delete' }];

  const handleCustomerContactData = (values: Contact) => {
    const updatedValues = {
      ...values,
      phone: values.phone1,
    };

    const contacts =
      createCustomerStore.customer.contacts?.map((contact) => {
        return contact.uniqueId === values.uniqueId
          ? { ...contact, ...updatedValues }
          : contact;
      }) || [];
    if (!contacts.some((contact) => contact.uniqueId === values.uniqueId)) {
      contacts.push({
        ...updatedValues,
        uniqueId: Math.floor(10000 + Math.random() * 90000),
      });
    }
    setupNewCustomerState({ contacts });
    handleClose();
  };

  const handleDeleteContact = (uniqueId: number) => {
    const contacts = createCustomerStore.customer.contacts?.filter(
      (contact) => contact.uniqueId !== uniqueId,
    );
    setupNewCustomerState({
      contacts,
    });
  };

  const handleClose = () => {
    closeModal(contactModalId);
    setSelectedContact(null);
  };

  return (
    <CollapsibleCard
      startTitle="Contact"
      accordion={false}
      endIcon={
        <Button
          variant="contained"
          color="primary"
          label="New Contact"
          onClick={() => openModal(contactModalId)}
          startIcon={<AccountPlusIcon size={20} />}
          dataTestId={formatDataTestId('New Contact', 'button')}
        />
      }
      class="mb-2"
    >
      <Box>
        <BasicTable
          columns={columns}
          tableContainerClasses="max-h-[400px] scrollbar-hide hover:scrollbar-default text-black! [&_td]:!border-[#e0e0e0] [&_th]:!border-[#e0e0e0]"
          tableHeaderClasses="!sticky top-0 bg-[#f2f6f8]! shadow-xs! z-1"
        >
          <Show when={createCustomerStore.customer.contacts?.length === 0}>
            <TableRow>
              <TableCell colSpan={3} class="text-center!">
                No Contacts to display
              </TableCell>
            </TableRow>
          </Show>
          <Index each={createCustomerStore.customer.contacts}>
            {(item) => (
              <TableRow class="hover:bg-[#D2E2ED]">
                <TableCell
                  class="cursor-pointer"
                  onClick={() => {
                    (setSelectedContact(item()), openModal(contactModalId));
                  }}
                >
                  <AddressCard
                    isCustomerContact={true}
                    mode="regular"
                    contact={{
                      userName: item().userName,
                      name: item().name,
                      email: item().email,
                      phone1: item().phone1,
                      extension1: item().extension1,
                      fax: item().fax,
                    }}
                    contactType={item().type}
                  />
                </TableCell>
                <TableCell
                  class="cursor-pointer"
                  onClick={() => {
                    (setSelectedContact(item()), openModal(contactModalId));
                  }}
                >
                  {item().type}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => handleDeleteContact(item().uniqueId!)}
                    dataTestId="new-customer-contact-delete-icon-button"
                  >
                    <DeleteIcon class="text-red-700" />
                  </IconButton>
                </TableCell>
              </TableRow>
            )}
          </Index>
        </BasicTable>
      </Box>

      <BasicModal
        id={contactModalId}
        title={`${selectedContact() ? 'Edit' : 'Add'} Contact`}
        width="80%"
        maxWidth="1980px"
        footer={false}
        showClose={false}
        onClose={() => handleClose()}
      >
        <AddNewContact
          modalId={contactModalId}
          initiatePath="CustomerDetails"
          onSubmit={(values) => handleCustomerContactData(values as Contact)}
          editObject={selectedContact}
          handleClose={handleClose}
        />
      </BasicModal>
    </CollapsibleCard>
  );
};

export default CustomerContact;
